import angular from 'angular';
import CurrentInstantGameLiabilityWidgetComponent from './current-instant-game-liability-widget-component';

export default angular
  .module('current-instant-game-liability-widget', [])
  .component('currentInstantGameLiabilityWidget', new CurrentInstantGameLiabilityWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/current-instant-game-liability/current-instant-game-liability-widget-module.js